import {
  SnippetElement,
  defineElement,
  on,
  onClick,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/snippets/new-mockup-gallery/new-mockup-gallery.ts
var NewMockupGallery = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.isStaticView = false;
    this.defaultIntervalMs = 3e3;
    this.desktopMediaQuery = window.matchMedia("(min-width: 1024px)");
    this.isAutoScrolling = false;
    this.scrollDirection = 1;
    this.lastScrollLeft = 0;
  }
  connectedCallback() {
    this.initScrollable();
  }
  disconnectedCallback() {
    this.stopAutoplay();
  }
  handleA11yToggle() {
    this.isStaticView = !this.isStaticView;
    this.updateA11yView();
  }
  updateA11yView() {
    var _a, _b, _c;
    if (!this.scrollView || !this.staticView || !this.a11yToggle)
      return;
    if (this.isStaticView) {
      this.scrollView.classList.add("hidden");
      this.staticView.classList.remove("hidden");
      this.a11yToggle.setAttribute("aria-pressed", "true");
      this.a11yToggle.textContent = (_a = this.a11yToggle.dataset.labelAnimated) != null ? _a : "";
      (_b = this.staticView.querySelector("[tabindex], a, button")) == null ? void 0 : _b.focus();
    } else {
      this.scrollView.classList.remove("hidden");
      this.staticView.classList.add("hidden");
      this.a11yToggle.setAttribute("aria-pressed", "false");
      this.a11yToggle.textContent = (_c = this.a11yToggle.dataset.labelStatic) != null ? _c : "";
    }
  }
  initScrollable() {
    if (!this.scrollableContainer)
      return;
    requestAnimationFrame(() => {
      this.centerScrollable();
      this.startAutoplay();
    });
  }
  centerScrollable() {
    if (!this.scrollableContainer)
      return;
    const savedBehavior = this.scrollableContainer.style.scrollBehavior;
    this.scrollableContainer.style.scrollBehavior = "auto";
    this.scrollableContainer.scrollLeft = (this.scrollableContainer.scrollWidth - this.scrollableContainer.clientWidth) / 2;
    this.scrollableContainer.style.scrollBehavior = savedBehavior;
  }
  getAutoplayConfig() {
    if (!this.scrollableContainer)
      return { enabled: false, durationMs: this.defaultIntervalMs };
    const isDesktop = this.desktopMediaQuery.matches;
    const enabledAttr = isDesktop ? this.scrollableContainer.dataset.autoplayDesktop : this.scrollableContainer.dataset.autoplayMobile;
    const durationAttr = isDesktop ? this.scrollableContainer.dataset.autoplayDurationDesktop : this.scrollableContainer.dataset.autoplayDurationMobile;
    const enabled = enabledAttr === "true";
    const durationSeconds = Number(durationAttr);
    const durationMs = Number.isFinite(durationSeconds) && durationSeconds > 0 ? durationSeconds * 1e3 : this.defaultIntervalMs;
    return { enabled, durationMs };
  }
  startAutoplay() {
    this.stopAutoplay();
    const config = this.getAutoplayConfig();
    if (!config.enabled)
      return;
    this.advanceSlide();
    this.autoplayIntervalId = window.setInterval(() => {
      this.advanceSlide();
    }, config.durationMs);
  }
  stopAutoplay() {
    if (this.resumeTimeoutId) {
      window.clearTimeout(this.resumeTimeoutId);
      this.resumeTimeoutId = void 0;
    }
    if (!this.autoplayIntervalId)
      return;
    window.clearInterval(this.autoplayIntervalId);
    this.autoplayIntervalId = void 0;
  }
  advanceSlide() {
    if (!this.scrollableContainer)
      return;
    const firstItem = this.scrollableContainer.querySelector("[scrollable-item]");
    if (!firstItem)
      return;
    const gap = 10;
    const slideWidth = firstItem.offsetWidth + gap;
    const maxScroll = this.scrollableContainer.scrollWidth - this.scrollableContainer.clientWidth;
    if (this.scrollDirection === 1 && this.scrollableContainer.scrollLeft + slideWidth >= maxScroll) {
      this.scrollDirection = -1;
    } else if (this.scrollDirection === -1 && this.scrollableContainer.scrollLeft - slideWidth <= 0) {
      this.scrollDirection = 1;
    }
    this.isAutoScrolling = true;
    this.scrollableContainer.scrollBy({ left: slideWidth * this.scrollDirection, behavior: "smooth" });
    window.setTimeout(() => {
      this.isAutoScrolling = false;
    }, 500);
  }
  handleScrollableScroll() {
    if (!this.scrollableContainer)
      return;
    if (!this.isAutoScrolling) {
      const currentLeft = this.scrollableContainer.scrollLeft;
      if (currentLeft !== this.lastScrollLeft) {
        this.scrollDirection = currentLeft > this.lastScrollLeft ? 1 : -1;
      }
      this.stopAutoplay();
      this.resumeAutoplayDelayed();
    }
    this.lastScrollLeft = this.scrollableContainer.scrollLeft;
  }
  resumeAutoplayDelayed() {
    if (this.resumeTimeoutId) {
      window.clearTimeout(this.resumeTimeoutId);
    }
    const config = this.getAutoplayConfig();
    if (!config.enabled)
      return;
    this.resumeTimeoutId = window.setTimeout(() => {
      this.resumeTimeoutId = void 0;
      this.startAutoplay();
    }, config.durationMs * 2);
  }
  handleScrollablePause() {
    this.stopAutoplay();
  }
  handleScrollableResume() {
    var _a;
    if (!((_a = this.scrollableContainer) == null ? void 0 : _a.matches(":focus-within"))) {
      this.resumeAutoplayDelayed();
    }
  }
  handleScrollableFocusIn(event) {
    this.stopAutoplay();
    const target = event.target;
    if (target == null ? void 0 : target.hasAttribute("scrollable-item")) {
      target.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    }
  }
  handleScrollableFocusOut(event) {
    var _a, _b;
    const related = event.relatedTarget;
    if (related && ((_a = this.scrollableContainer) == null ? void 0 : _a.contains(related)))
      return;
    if (!((_b = this.scrollableContainer) == null ? void 0 : _b.matches(":hover"))) {
      this.resumeAutoplayDelayed();
    }
  }
};
__decorateClass([
  query("[data-a11y-toggle]")
], NewMockupGallery.prototype, "a11yToggle", 2);
__decorateClass([
  query("[data-scroll-view]")
], NewMockupGallery.prototype, "scrollView", 2);
__decorateClass([
  query("[data-static-view]")
], NewMockupGallery.prototype, "staticView", 2);
__decorateClass([
  query("[scrollable-container]")
], NewMockupGallery.prototype, "scrollableContainer", 2);
__decorateClass([
  onClick("[data-a11y-toggle]")
], NewMockupGallery.prototype, "handleA11yToggle", 1);
__decorateClass([
  on("scroll", "[scrollable-container]")
], NewMockupGallery.prototype, "handleScrollableScroll", 1);
__decorateClass([
  on("mouseenter", "[scrollable-container]")
], NewMockupGallery.prototype, "handleScrollablePause", 1);
__decorateClass([
  on("mouseleave", "[scrollable-container]")
], NewMockupGallery.prototype, "handleScrollableResume", 1);
__decorateClass([
  on("focusin", "[scrollable-container]")
], NewMockupGallery.prototype, "handleScrollableFocusIn", 1);
__decorateClass([
  on("focusout", "[scrollable-container]")
], NewMockupGallery.prototype, "handleScrollableFocusOut", 1);
NewMockupGallery = __decorateClass([
  defineElement("new-mockup-gallery")
], NewMockupGallery);
export {
  NewMockupGallery
};
